import { TZDateMini } from '@date-fns/tz';
import { createContext, type Dispatch, type Context } from 'react';
import { getWeekStartByLocale } from 'weekstart';

import {
  getRegionalFormat,
  getTimezone,
} from '@dynatrace-sdk/user-preferences';

import type { TimeframeV2 } from '../../../core/types/time.js';
import type {
  CalendarReducerAction,
  CalendarState,
} from '../types/shared-types.js';

/** @internal */
export type CalendarContextProps = {
  onChange?: (value: string | null | TimeframeV2) => void;
  state: CalendarState;
  dispatch: Dispatch<CalendarReducerAction>;
  readOnly: boolean;
};

// Current date
const today = TZDateMini.tz(getTimezone());

/**
 * @internal
 */
export const initialState: CalendarState = {
  activeDate: today,
  currentView: 'day',
  isCalendarBodyFocused: null,
  selectedDate: null,
  today,
  weekStartsOn: getWeekStartByLocale(getRegionalFormat()),
  type: 'single',
  timeOffset: 'startOfDay',
};

/**
 * Calendar context, used to access the state and dispatcher in other components
 * @internal
 */
export const CalendarContext: Context<CalendarContextProps> =
  createContext<CalendarContextProps>({
    state: initialState,
    dispatch: () => null,
    onChange: () => null,
    readOnly: false,
  });
